import { axiosStudentInstance } from "./studentAuth"
import type { StudentApiEnvelope } from "./studentQuestions"
import type { PaperSessionStatus } from "../page/Student/PracticePapers/types"

export interface StudentDashboardStats {
  totalAttempts: number
  papersInProgress: number
  papersCompleted: number
  aiAssessmentsCount: number
  avgAiAssessmentScore: number | null
  savedItemsCount: number
  bookmarkedCount: number
  notesCount: number
}

export const emptyDashboardStats = (): StudentDashboardStats => ({
  totalAttempts: 0,
  papersInProgress: 0,
  papersCompleted: 0,
  aiAssessmentsCount: 0,
  avgAiAssessmentScore: null,
  savedItemsCount: 0,
  bookmarkedCount: 0,
  notesCount: 0,
})

export const getStudentDashboardStats = () =>
  axiosStudentInstance.get<StudentApiEnvelope<StudentDashboardStats>>(
    "/dashboard/stats/"
  )

export type RevisionGoalStatus = "active" | "completed" | "overdue"

export interface StudentRevisionGoalPaper {
  id: string
  title: string
  status: PaperSessionStatus | "unavailable" | string
  subjectId?: string
  subjectTitle?: string
  questionCount?: number
  progressPercent?: number
}

export interface StudentRevisionGoal {
  id: string
  title: string
  task?: string
  target: string
  currentProgress: number
  targetCount: number
  progressPercent: number
  progress?: number
  dueDate: string
  dueAt?: string
  status: RevisionGoalStatus
  subjectId?: string
  subject: string
  papers: StudentRevisionGoalPaper[]
}

export interface CreateStudentRevisionGoalPayload {
  subjectId: string
  title: string
  paperIds: string[]
  dueDate: string
  restartPapers?: boolean
}

export const listStudentRevisionGoals = () =>
  axiosStudentInstance.get<StudentApiEnvelope<StudentRevisionGoal[]>>(
    "/dashboard/goals/"
  )

export const createStudentRevisionGoal = (
  payload: CreateStudentRevisionGoalPayload
) =>
  axiosStudentInstance.post<StudentApiEnvelope<StudentRevisionGoal>>(
    "/dashboard/goals/",
    payload
  )

export type StudentDashboardActivityTone =
  | "primary"
  | "blue"
  | "emerald"
  | "red"
  | "amber"

export interface StudentDashboardActivity {
  id: string
  type: string
  title: string
  description: string
  occurredAt: string
  tone: StudentDashboardActivityTone | string
  href: string
  resourceType?: string
  resourceId?: string
  subjectId?: string | null
  subjectTitle?: string | null
}

export const DASHBOARD_ACTIVITY_PREVIEW_LIMIT = 4
export const DASHBOARD_ACTIVITY_MAX_LIMIT = 20

export const listStudentDashboardActivity = (
  limit = DASHBOARD_ACTIVITY_PREVIEW_LIMIT
) =>
  axiosStudentInstance.get<StudentApiEnvelope<StudentDashboardActivity[]>>(
    "/dashboard/activity/",
    { params: { limit } }
  )
